export const incentiveConstants = {
     // about campaign constants start

     INCENTIVE_ADD_ABOUT_CAMPAIGN_REQUEST:
          "INCENTIVE_ADD_ABOUT_CAMPAIGN_REQUEST",
     INCENTIVE_ADD_ABOUT_CAMPAIGN_COMPLETE:
          "INCENTIVE_ADD_ABOUT_CAMPAIGN_COMPLETE",

     INCENTIVE_ABOUT_REVISION_CONTENT_LIST_REQUEST:
          "INCENTIVE_ABOUT_REVISION_CONTENT_LIST_REQUEST",
          INCENTIVE_ABOUT_REVISION_CONTENT_LIST_COMPLETE:
          "INCENTIVE_ABOUT_REVISION_CONTENT_LIST_COMPLETE",

     INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_REQUEST:
     "INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_REQUEST",
     INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_COMPLETE:
     "INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_COMPLETE",

     INCENTIVE_ABOUT_CONTENT_GET_REQUEST:
     "INCENTIVE_ABOUT_CONTENT_GET_REQUEST",
     INCENTIVE_ABOUT_CONTENT_GET_COMPLETE:
     "INCENTIVE_ABOUT_CONTENT_GET_COMPLETE",

     INCENTIVE_ABOUT_CONTENT_PUBLISH_REQUEST:
     "INCENTIVE_ABOUT_CONTENT_PUBLISH_REQUEST",
     INCENTIVE_ABOUT_CONTENT_PUBLISH_COMPLETE:
     "INCENTIVE_ABOUT_CONTENT_PUBLISH_COMPLETE",

     // about campaign constants end

     INCENTIVE_TABLE_LIST_REQUEST: "INCENTIVE_TABLE_LIST_REQUEST",
     INCENTIVE_TABLE_LIST_COMPLETE: "INCENTIVE_TABLE_LIST_COMPLETE",

     INCENTIVE_DELETE_REQUEST: "INCENTIVE_DELETE_REQUEST",
     INCENTIVE_DELETE_COMPLETE: "INCENTIVE_DELETE_COMPLETE",

     INCENTIVE_TYPES_REQUEST: "INCENTIVE_TYPES_REQUEST",
     INCENTIVE_TYPES_COMPLETE: "INCENTIVE_TYPES_COMPLETE",

     INCENTIVE_TABLE_SEARCH_LIST_REQUEST: "INCENTIVE_TABLE_SEARCH_LIST_REQUEST",
     INCENTIVE_TABLE_SEARCH_LIST_COMPLETE:
          "INCENTIVE_TABLE_SEARCH_LIST_COMPLETE",

     INCENTIVE_CHANGE_STATUS_REQUEST: "INCENTIVE_CHANGE_STATUS_REQUEST",
     INCENTIVE_CHANGE_STATUS_COMPLETE: "INCENTIVE_CHANGE_STATUS_COMPLETE",

     GET_CAMPAIGN_TYPES_REQUEST: "GET_CAMPAIGN_TYPES_REQUEST",
     GET_CAMPAIGN_TYPES_COMPLETE: "GET_CAMPAIGN_TYPES_COMPLETE",

     GET_CAMPAIGN_PARTICIPANTS_REQUEST: "GET_CAMPAIGN_PARTICIPANTS_REQUEST",
     GET_CAMPAIGN_PARTICIPANTS_COMPLETE: "GET_CAMPAIGN_PARTICIPANTS_COMPLETE",

     GET_CAMPAIGN_SALES_REQUEST: "GET_CAMPAIGN_SALES_REQUEST",
     GET_CAMPAIGN_SALES_COMPLETE: "GET_CAMPAIGN_SALES_COMPLETE",

     GET_CAMPAIGN_TEMPLATE_TYPES_REQUEST: "GET_CAMPAIGN_TEMPLATE_TYPES_REQUEST",
     GET_CAMPAIGN_TEMPLATE_TYPES_COMPLETE:
          "GET_CAMPAIGN_TEMPLATE_TYPES_COMPLETE",

     GET_CAMPAIGN_PRODUCTS_REQUEST: "GET_CAMPAIGN_PRODUCTS_REQUEST",
     GET_CAMPAIGN_PRODUCTS_COMPLETE: "GET_CAMPAIGN_PRODUCTS_COMPLETE",

     GET_PARTICIPANT_LIST_REQUEST: "GET_PARTICIPANT_LIST_REQUEST",
     GET_PARTICIPANT_LIST_COMPLETE: "GET_PARTICIPANT_LIST_COMPLETE",

     CREATION_STEP_ONE_REQUEST: "CREATION_STEP_ONE_REQUEST",
     CREATION_STEP_ONE_COMPLETE: "CREATION_STEP_ONE_COMPLETE",

     GET_ABOUT_CAMPAIGN_STEP_ONE_REQUEST: "GET_ABOUT_CAMPAIGN_STEP_ONE_REQUEST",
     GET_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE:
          "GET_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE",

     UPDATE_ABOUT_CAMPAIGN_STEP_ONE_REQUEST:
          "UPDATE_ABOUT_CAMPAIGN_STEP_ONE_REQUEST",
     UPDATE_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE:
          "UPDATE_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE",

     INCENTIVE_HEADER_CONTENT_ADD_REQUEST:
          "INCENTIVE_HEADER_CONTENT_ADD_REQUEST",
     INCENTIVE_HEADER_CONTENT_ADD_COMPLETE:
          "INCENTIVE_HEADER_CONTENT_ADD_COMPLETE",

     INCENTIVE_HEADER_CONTENT_EDIT_REQUEST:
          "INCENTIVE_HEADER_CONTENT_EDIT_REQUEST",
     INCENTIVE_HEADER_CONTENT_EDIT_COMPLETE:
          "INCENTIVE_HEADER_CONTENT_EDIT_COMPLETE",

     INCENTIVE_HEADER_CONTENT_LIST_REQUEST:
          "INCENTIVE_HEADER_CONTENT_LIST_REQUEST",
     INCENTIVE_HEADER_CONTENT_LIST_COMPLETE:
          "INCENTIVE_HEADER_CONTENT_LIST_COMPLETE",

     INCENTIVE_HEADER_CONTENT_GET_REQUEST:
          "INCENTIVE_HEADER_CONTENT_GET_REQUEST",
     INCENTIVE_HEADER_CONTENT_GET_COMPLETE:
          "INCENTIVE_HEADER_CONTENT_GET_COMPLETE",

     INCENTIVE_HEADER_CONTENT_PUBLISH_REQUEST:
          "INCENTIVE_HEADER_CONTENT_PUBLISH_REQUEST",
     INCENTIVE_HEADER_CONTENT_PUBLISH_COMPLETE:
          "INCENTIVE_HEADER_CONTENT_PUBLISH_COMPLETE",

     GET_PARTICIPANT_DATA_TEMPLATE_REQUEST:
          "GET_PARTICIPANT_DATA_TEMPLATE_REQUEST",
     GET_PARTICIPANT_DATA_TEMPLATE_COMPLETE:
          "GET_PARTICIPANT_DATA_TEMPLATE_COMPLETE",

     GET_SALSE_DATA_TEMPLATE_REQUEST: "GET_SALSE_DATA_TEMPLATE_REQUEST",
     GET_SALSE_DATA_TEMPLATE_COMPLETE: "GET_SALSE_DATA_TEMPLATE_COMPLETE",

     LIST_CAMPAIGN_PARTICIPANTS_REQUEST: "LIST_CAMPAIGN_PARTICIPANTS_REQUEST",
     LIST_CAMPAIGN_PARTICIPANTS_COMPLETE: "LIST_CAMPAIGN_PARTICIPANTS_COMPLETE",

     ADD_CAMPAIGN_PARTICIPANTS_REQUEST: "ADD_CAMPAIGN_PARTICIPANTS_REQUEST",
     ADD_CAMPAIGN_PARTICIPANTS_COMPLETE: "ADD_CAMPAIGN_PARTICIPANTS_COMPLETE",


     INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_REQUEST:
          "INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_REQUEST",
          INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_COMPLETE:
          "INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_COMPLETE",

     

     // start of quick read

     INCENTIVE_QUICK_CONTENT_ADD_REQUEST:
          "INCENTIVE_QUICK_CONTENT_ADD_REQUEST",
     INCENTIVE_QUICK_CONTENT_ADD_COMPLETE:
          "INCENTIVE_QUICK_CONTENT_ADD_COMPLETE",

     INCENTIVE_QUICK_CONTENT_EDIT_REQUEST:
          "INCENTIVE_QUICK_CONTENT_EDIT_REQUEST",
     INCENTIVE_QUICK_CONTENT_EDIT_COMPLETE:
          "INCENTIVE_QUICK_CONTENT_EDIT_COMPLETE",

     INCENTIVE_QUICK_CONTENT_LIST_REQUEST:
          "INCENTIVE_QUICK_CONTENT_LIST_REQUEST",
     INCENTIVE_QUICK_CONTENT_LIST_COMPLETE:
          "INCENTIVE_QUICK_CONTENT_LIST_COMPLETE",

     INCENTIVE_QUICK_CONTENT_GET_REQUEST:
          "INCENTIVE_QUICK_CONTENT_GET_REQUEST",
     INCENTIVE_QUICK_CONTENT_GET_COMPLETE:
          "INCENTIVE_QUICK_CONTENT_GET_COMPLETE",

     INCENTIVE_QUICK_CONTENT_PUBLISH_REQUEST:
          "INCENTIVE_QUICK_CONTENT_PUBLISH_REQUEST",
     INCENTIVE_QUICK_CONTENT_PUBLISH_COMPLETE:
     "INCENTIVE_QUICK_CONTENT_PUBLISH_COMPLETE",

     INCENTIVE_QUICK_REVISION_CONTENT_LIST_REQUEST:
     "INCENTIVE_QUICK_REVISION_CONTENT_LIST_REQUEST",
     INCENTIVE_QUICK_REVISION_CONTENT_LIST_COMPLETE:
     "INCENTIVE_QUICK_REVISION_CONTENT_LIST_COMPLETE",

     INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_REQUEST:
     "INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_REQUEST",
     INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_COMPLETE:
     "INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_COMPLETE",

     // end of quick read

     // start of term and condition

     INCENTIVE_TERM_CONTENT_ADD_REQUEST:
          "INCENTIVE_TERM_CONTENT_ADD_REQUEST",
     INCENTIVE_TERM_CONTENT_ADD_COMPLETE:
          "INCENTIVE_TERM_CONTENT_ADD_COMPLETE",

     INCENTIVE_TERM_CONTENT_EDIT_REQUEST:
          "INCENTIVE_TERM_CONTENT_EDIT_REQUEST",
     INCENTIVE_TERM_CONTENT_EDIT_COMPLETE:
          "INCENTIVE_TERM_CONTENT_EDIT_COMPLETE",

     INCENTIVE_TERM_CONTENT_LIST_REQUEST:
          "INCENTIVE_TERM_CONTENT_LIST_REQUEST",
     INCENTIVE_TERM_CONTENT_LIST_COMPLETE:
          "INCENTIVE_TERM_CONTENT_LIST_COMPLETE",

     INCENTIVE_TERM_CONTENT_GET_REQUEST:
          "INCENTIVE_TERM_CONTENT_GET_REQUEST",
     INCENTIVE_TERM_CONTENT_GET_COMPLETE:
          "INCENTIVE_TERM_CONTENT_GET_COMPLETE",

     INCENTIVE_TERM_CONTENT_PUBLISH_REQUEST:
          "INCENTIVE_TERM_CONTENT_PUBLISH_REQUEST",
     INCENTIVE_TERM_CONTENT_PUBLISH_COMPLETE:
     "INCENTIVE_TERM_CONTENT_PUBLISH_COMPLETE",

     INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_REQUEST:
     "INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_REQUEST",
     INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_COMPLETE:
     "INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_COMPLETE",

     // end of term and condition

     // start of faq 

     INCENTIVE_FAQ_CONTENT_ADD_REQUEST:
          "INCENTIVE_FAQ_CONTENT_ADD_REQUEST",
     INCENTIVE_FAQ_CONTENT_ADD_COMPLETE:
          "INCENTIVE_FAQ_CONTENT_ADD_COMPLETE",

     INCENTIVE_FAQ_CONTENT_EDIT_REQUEST:
          "INCENTIVE_FAQ_CONTENT_EDIT_REQUEST",
     INCENTIVE_FAQ_CONTENT_EDIT_COMPLETE:
          "INCENTIVE_FAQ_CONTENT_EDIT_COMPLETE",

     INCENTIVE_FAQ_CONTENT_LIST_REQUEST:
          "INCENTIVE_FAQ_CONTENT_LIST_REQUEST",
     INCENTIVE_FAQ_CONTENT_LIST_COMPLETE:
          "INCENTIVE_FAQ_CONTENT_LIST_COMPLETE",

     INCENTIVE_FAQ_CONTENT_GET_REQUEST:
          "INCENTIVE_FAQ_CONTENT_GET_REQUEST",
     INCENTIVE_FAQ_CONTENT_GET_COMPLETE:
          "INCENTIVE_FAQ_CONTENT_GET_COMPLETE",

     INCENTIVE_FAQ_CONTENT_PUBLISH_REQUEST:
          "INCENTIVE_FAQ_CONTENT_PUBLISH_REQUEST",
     INCENTIVE_FAQ_CONTENT_PUBLISH_COMPLETE:
     "INCENTIVE_FAQ_CONTENT_PUBLISH_COMPLETE",

     INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_REQUEST:
     "INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_REQUEST",
     INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_COMPLETE:
     "INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_COMPLETE",


     // end of faq
     LIST_CAMPAIGN_ADMINS_REQUEST: "LIST_CAMPAIGN_ADMINS_REQUEST",
     LIST_CAMPAIGN_ADMINS_COMPLETE: "LIST_CAMPAIGN_ADMINS_COMPLETE",

     ADD_CAMPAIGN_ADMINS_REQUEST: "ADD_CAMPAIGN_ADMINS_REQUEST",
     ADD_CAMPAIGN_ADMINS_COMPLETE: "ADD_CAMPAIGN_ADMINS_COMPLETE",

     INCENTIVE_CONTENT_UNPUBLISH_REQUEST:
     "INCENTIVE_CONTENT_UNPUBLISH_REQUEST",
     INCENTIVE_CONTENT_UNPUBLISH_COMPLETE:
     "INCENTIVE_CONTENT_UNPUBLISH_COMPLETE",
};
